import React, { FunctionComponent } from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import type { StackNavigationProp } from '@react-navigation/stack';
import { Root } from '../screens/root/Root';
import { FormsScreen } from '../screens/forms/FormsScreen';
import { DocumentsScreen } from '../screens/documents/DocumentsScreen';
import { BrightcovePlayerScreen } from '../screens/brightcove-player/BrightcovePlayerScreen';

const Stack = createStackNavigator<RootNavigationParamList>();

export const RootNavigation: FunctionComponent<RootNavigationProps> = () => {
  return (
    <Stack.Navigator
      initialRouteName="redirect"
      screenOptions={{ headerShown: false }}
    >
      <Stack.Group>
        <Stack.Screen
          name="redirect" // for default redirection logics
          component={Root}
          options={{ title: 'Redirecting' }}
        />
        <Stack.Screen
          name="forms"
          component={FormsScreen}
          options={{ title: 'Redirecting Forms' }}
        />
        <Stack.Screen
          name="documents"
          component={DocumentsScreen}
          options={{ title: 'Redirecting documents' }}
        />
        <Stack.Screen
          name="brightcove-player"
          component={BrightcovePlayerScreen}
          options={{ title: 'Redirecting videos' }}
        />
      </Stack.Group>
    </Stack.Navigator>
  );
};

interface RootNavigationProps {}

export type RootNavigationParamList = {
  redirect: undefined; // for default redirection logics
  forms: FormsScreenParams;
  documents: undefined;
  ['brightcove-player']: BrightcovePlayerScreenParams;
};

export type RootStackNavigationProp =
  StackNavigationProp<RootNavigationParamList>;

export type FormsScreenParams = {
  form_id: string;
};

export type BrightcovePlayerScreenParams = {
  video_id: string;
  account_id: string;
  player_id: string;
};
